// Configuration API partagée entre Frontend et Admin
const API_CONFIG = {
  // URL de base de votre backend PHP
  BASE_URL: process.env.REACT_APP_API_BASE || 'https://update.senoffre.com/api',
  
  // Token d'authentification de l'application
  API_TOKEN: process.env.REACT_APP_API_TOKEN || 'senoffre_api_token_2024_secure_key_xyz123',
  
  // Endpoints principaux
  ENDPOINTS: {
    AUTH: {
      LOGIN: '/auth/login',
      REGISTER: '/auth/register',
      LOGOUT: '/auth/logout',
      REFRESH: '/auth/refresh',
      PROFILE: '/auth/profile'
    },
    USERS: {
      LIST: '/users',
      CREATE: '/users',
      UPDATE: '/users',
      DELETE: '/users'
    },
    PAYMENTS: {
      LIST: '/payments',
      CREATE: '/payments',
      METHODS: '/payment-methods',
      WAVE_INITIATE: '/payments/wave/initiate'
    },
    CATEGORIES: {
      LIST: '/categories',
      CREATE: '/categories',
      UPDATE: '/categories',
      DELETE: '/categories'
    },
    COMPANIES: {
      LIST: '/companies',
      CREATE: '/companies',
      UPDATE: '/companies',
      DELETE: '/companies'
    },
    CONTACT: {
      SEND: '/contact-messages/send',
      LIST: '/contact-messages',
      READ: '/contact-messages/:id/read',
      REPLY: '/contact-messages/:id/reply'
    }
  },
  
  // Headers par défaut
  DEFAULT_HEADERS: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
};

export default API_CONFIG;
